import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-hide-reply-modal',
    templateUrl: './hide-reply-modal.component.html',
    styleUrls: ['./hide-reply-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, FormsModule],
})
export class HideReplyModalComponent implements OnDestroy {
    confirmCallback: (isUserBlocked: boolean) => void;
    isUserBlocked = false;
    onClose: Subject<boolean> = new Subject();

    constructor(private modalRef: BsModalRef) {}

    confirm(): void {
        this.onClose.next(true);
        this.onClose.complete();

        if (this.confirmCallback) {
            this.confirmCallback(this.isUserBlocked === true ? true : null);
        }

        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }

    ngOnDestroy() {
        this.onClose.next(false);
        this.onClose.complete();
    }
}
